<div>
  <div *ngIf="!previewMode && files.length < limit">
    <app-drop-files-area
      [disabled]="processing"
      [vertical]="!files.length"
      [limit]="limit"
      (onUpload)="filesDropped($event)"
    />
  </div>

  <div class="upload-list" *ngIf="files.length">
    <!-- <div class="header" *ngIf="!previewMode">
      <h3>Manage files</h3>
      <p>Overall configuration</p>
    </div> -->
    <div class="body">
      <div class="master-tagging" *ngIf="!previewMode">
        <div style="width: 50%">
          <label>Tags</label>
          <nz-select
            nzMode="tags"
            nzPlaceHolder="Select tags"
            [(ngModel)]="masterTags"
            style="width: 100%"
            [nzDisabled]="processing"
            nzSize="small"
          >
            <nz-option
              *ngFor="let option of fileManagerService.tags$ | async"
              [nzLabel]="option.label"
              [nzValue]="option.value"
            />
          </nz-select>
        </div>
        <div style="width: 50%">
          <label>Category</label>
          <nz-select
            nzPlaceHolder="Select category"
            [(ngModel)]="masterCategory"
            style="width: 100%"
            [nzDisabled]="processing"
            nzSize="small"
          >
            <nz-option
              *ngFor="let option of fileManagerService.categories$ | async"
              [nzLabel]="option.label"
              [nzValue]="option.value"
              [nzDisabled]="!option.status"
              nzCustomContent
            >
              <div style="display: inline-flex; gap: 8px; align-items: center">
                <div
                  [style.background]="option.color"
                  style="width: 12px; height: 12px; border-radius: 2px"
                ></div>
                {{ option.label }}
              </div>
            </nz-option>
          </nz-select>
        </div>
        <button
          nz-button
          nzType="default"
          (click)="applyMasterFlags()"
          [disabled]="processing"
          nzSize="small"
          style="padding: 0px 16px"
        >
          Apply
        </button>
      </div>

      <div
        style="
          display: inline-flex;
          flex-direction: column;
          width: 100%;
          gap: 6px;
          margin: 12px 0px 6px 0px;
        "
      >
        <app-file-manager-card
          class="file-manager-wrapper-card"
          [ngClass]="{
            borderless: borderless,
          }"
          *ngFor="let file of files; let i = index"
          [file]="file"
          [selectable]="false"
          [clickable]="clickable"
          [view]="'details'"
          [showActions]="true"
          [actions]="cardActions"
          (onRemove)="onRemoveFile($event)"
          (onUpdate)="onUpdateFile($event)"
          [borderless]="borderless"
          [previewMode]="previewMode"
          (clicked)="fileManagerService.openAttachments({ files, index: i })"
        />
      </div>
    </div>
  </div>

  <div *ngIf="showUploadButton && files.length">
    <button
      nz-button
      nzType="primary"
      (click)="upload()"
      [disabled]="processing"
      style="width: 100%"
    >
      Update Files
    </button>
  </div>
</div>
